(() => {
  const dialog = document.getElementById('dc-pop');
  const dataEl = document.getElementById('dc-pop-data');
  if (!dialog || !dataEl || !dialog.showModal || dialog.dataset.ready) return;
  let data;
  try { data = JSON.parse(dataEl.textContent); } catch (_) { return; }
  dialog.dataset.ready = '1';
  const DAY = 86400000, SESSION = 30 * 60000;
  const forced = new URLSearchParams(location.search).get('dc_pop');
  const store = {
    get(k, fallback = null) { try { return JSON.parse(localStorage.getItem(k)) ?? fallback; } catch (_) { return fallback; } },
    set(k, v) { try { localStorage.setItem(k, JSON.stringify(v)); return true; } catch (_) { return false; } },
  };
  const path = location.pathname.toLowerCase().replace(/\/$/, '') || '/';
  const context = (data.context || '').toLowerCase();
  const forbidden = /\/(cart|checkout|checkouts|account|search)(\/|$)/.test(path) ||
    /\/(pages\/)?[^/]*(quote|trade-?in|contact|appointment|booking|registration)[^/]*$/.test(path);
  if (!forced && forbidden) return;
  const today = () => new Intl.DateTimeFormat('en-CA', {timeZone:'America/New_York'}).format(new Date());
  const live = c => (!c.start || c.start <= today()) && (!c.end || today() <= c.end) && (c.image || (c.steps && c.steps.length));
  const equipment = /scanner|3d printer|3d-printer|milling machine|milling-machine|equipment|cbct|dental chair|vhf [a-z]\d/.test(context) &&
    !/resin|zirconia|pmma|scanbody|scan body|scan-body|tips?\b|tray|accessor|spare|replacement|discs?\b|blocks?\b|burs?\b|filter/.test(context);
  const destinationHere = c => {
    const u = new URL(c.href, location.origin);
    const dest = u.pathname.replace(/\/$/, '') || '/';
    return u.origin === location.origin && (path === dest || path.startsWith(dest + '-'));
  };
  const relevant = c => {
    if (c.targeting === 'cbct-chair') {
      if (!['product', 'collection', 'page'].includes(data.page)) return false;
      if (destinationHere(c)) return true;
      const subject = `${context} ${path}`;
      return /\bcbct\b|\bchairs?\b/.test(subject) &&
        !/compatible|scanbody|scan[- ]body|abutment|implant|accessor|replacement|spare|cover|upholstery|parts?\b/.test(subject);
    }
    if ((c.exclude || []).some(w => context.includes(w))) return false;
    if (data.page === 'index' || data.page === 'list-collections') return true;
    if (c.equipmentOnly) return equipment;
    return (c.match || []).some(w => context.includes(w));
  };
  const object = value => value && typeof value === 'object' && !Array.isArray(value) ? value : {};
  const session = () => {
    let s = object(store.get('dc-pop-session'));
    if (!s.last || Date.now() - s.last >= SESSION) s = {shown:false, suppressed:false};
    s.last = Date.now();
    return s;
  };
  const touch = () => store.set('dc-pop-session', session());
  const suppressed = () => {
    const s = session();
    return s.shown || s.suppressed || Date.now() - Number(store.get('dc-pop-last', 0)) < DAY;
  };
  const cooling = c => Number(object(store.get('dc-pop-cooldown'))[c.id] || 0) > Date.now();
  let pool = data.campaigns.filter(c => live(c) && (!c.targeting || relevant(c)) && (forced ? c.id === forced : relevant(c) && (!destinationHere(c) || c.allowOnDestination) && !cooling(c)));
  if (!pool.length || (!forced && (suppressed() || !touch()))) return;
  const seen = object(store.get('dc-pop-seen'));
  // Shuffle equal candidates first, so new visitors do not all see list item one.
  for (let i = pool.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [pool[i], pool[j]] = [pool[j], pool[i]];
  }
  pool.sort((a, b) => {
    const fresh = Number(!!seen[a.id]) - Number(!!seen[b.id]);
    if (fresh) return fresh;
    if (data.page !== 'index' && data.page !== 'list-collections') {
      const priority = (b.priority || 50) - (a.priority || 50);
      if (priority) return priority;
    }
    return (seen[a.id] || 0) - (seen[b.id] || 0);
  });
  const c = pool[0], q = s => dialog.querySelector(s);
  dialog.dataset.campaign = c.id;
  if (c.masthead) { q('.dc-pop__masthead img').src = c.masthead.src; q('.dc-pop__masthead img').alt = c.masthead.alt; }
  const logos = q('.dc-pop__logos');
  logos.replaceChildren();
  (c.logos || []).forEach((logo, i) => {
    if (i) { const divider = document.createElement('span'); divider.setAttribute('aria-hidden', 'true'); logos.append(divider); }
    const im = document.createElement('img'); im.src = logo.src; im.alt = logo.alt; logos.append(im);
  });
  logos.hidden = !(c.logos || []).length;
  q('.dc-pop__eyebrow').textContent = c.eyebrow || '';
  q('.dc-pop__fine').textContent = c.fine || '';
  q('.dc-pop__days').textContent = c.end ? (c.end === today() ? 'Ends today' : `Through ${new Date(c.end + 'T12:00:00').toLocaleDateString('en-US', {month:'short', day:'numeric', year:'numeric'})}`) : '';
  const link = new URL(destinationHere(c) && c.onLandingHref ? c.onLandingHref : c.href, location.origin);
  link.searchParams.set('utm_source', 'dentcore'); link.searchParams.set('utm_medium', 'popup'); link.searchParams.set('utm_campaign', c.id);
  q('.dc-pop__cta').href = link.toString(); q('.dc-pop__cta span').textContent = c.cta;
  const img = q('.dc-pop__img');
  // A campaign may walk the visitor through a few short steps (what it is, why, which one) before the CTA.
  const steps = Array.isArray(c.steps) && c.steps.length ? c.steps : null;
  const stepper = q('.dc-pop__stepper'), dots = q('.dc-pop__dots'), chips = q('.dc-pop__chips');
  let step = 0;
  const render = () => {
    const s = steps ? steps[step] : c;
    const last = !steps || step === steps.length - 1;
    q('.dc-pop__title').textContent = s.title;
    q('.dc-pop__subtitle').textContent = s.subtitle || '';
    img.src = s.image; img.alt = s.imageAlt || s.title;
    chips.replaceChildren(...(s.chips || []).map(t => { const li = document.createElement('li'); li.textContent = t; return li; }));
    chips.hidden = !steps && !(s.chips || []).length;
    chips.classList.toggle('is-empty', !(s.chips || []).length);
    dialog.dataset.step = steps ? String(step + 1) : '';
    stepper.hidden = !steps;
    if (steps) {
      dots.replaceChildren(...steps.map((_, i) => { const d = document.createElement('i'); if (i === step) d.className = 'is-on'; return d; }));
      q('.dc-pop__back').classList.toggle('is-off', step === 0);
    }
    q('.dc-pop__next').hidden = last;
    q('.dc-pop__cta').hidden = !last;
  };
  if (steps) {
    steps.slice(1).forEach(s => { const pre = new Image(); pre.src = s.image; });
    q('.dc-pop__next').addEventListener('click', () => { step = Math.min(step + 1, steps.length - 1); render(); publish('dc_popup_step'); (step === steps.length - 1 ? q('.dc-pop__cta') : q('.dc-pop__next')).focus({preventScroll:true}); });
    q('.dc-pop__back').addEventListener('click', () => { step = Math.max(step - 1, 0); render(); q('.dc-pop__next').focus({preventScroll:true}); });
  }
  render();
  const publish = name => { if (forced) return; try { window.Shopify?.analytics?.publish(name, {campaign:c.id, page:data.page}); } catch (_) {} };
  let opened = false, clicked = false, previousOverflow = '', previousFocus = null, interval;
  const cooldown = days => { if (!forced) { const map = object(store.get('dc-pop-cooldown')); map[c.id] = Date.now() + days * DAY; store.set('dc-pop-cooldown', map); } };
  const close = () => { if (dialog.open) dialog.close(); };
  q('.dc-pop__close').addEventListener('click', close);
  dialog.addEventListener('click', e => { if (e.target === dialog) close(); });
  dialog.addEventListener('close', () => {
    document.body.style.overflow = previousOverflow;
    if (previousFocus?.isConnected) previousFocus.focus({preventScroll:true});
    if (!clicked) cooldown(7);
    publish('dc_popup_close');
  });
  q('.dc-pop__cta').addEventListener('click', () => { clicked = true; cooldown(14); publish('dc_popup_click'); });
  const stopVisit = () => {
    if (forced) return;
    const s = session(); s.suppressed = true; store.set('dc-pop-session', s);
    clearInterval(interval); close();
  };
  // Capture before theme AJAX handlers; never alter the original submission.
  document.addEventListener('submit', e => { if (e.target.matches?.('form:not([role="search"])')) stopVisit(); }, true);
  document.addEventListener('input', e => {
    const form = e.target.closest?.('form');
    if (form && !form.matches('[role="search"], [action*="/search"]') && e.target.matches('input:not([type="hidden"]),textarea,select')) stopVisit();
  }, true);
  document.addEventListener('click', e => { if (e.target.closest?.('form[action*="/cart/add"] [type="submit"],button[name="add"]')) stopVisit(); }, true);
  ['cart:updated', 'cart:change', 'cart:added'].forEach(name => document.addEventListener(name, stopVisit));
  window.addEventListener('klaviyoForms', e => { if (['open', 'submit'].includes(e.detail?.type)) stopVisit(); });
  const visible = el => { const s = getComputedStyle(el); return el.getClientRects().length > 0 && s.display !== 'none' && s.visibility !== 'hidden' && s.opacity !== '0'; };
  const blocked = () => {
    if (document.hidden || document.activeElement?.matches('input,textarea,select,[contenteditable="true"]')) return true;
    return [...document.querySelectorAll('dialog[open]:not(#dc-pop),[role="dialog"][aria-modal="true"]:not(#dc-pop),.menu-drawer-container[open],cart-drawer.active')].some(visible);
  };
  const show = () => {
    if (opened || !live(c) || blocked() || (!forced && (suppressed() || cooling(c))) || !img.complete || !img.naturalWidth) return false;
    // Recheck shared storage at display time, including other tabs opened earlier.
    if (!forced) {
      const s = session(); s.shown = true;
      if (!store.set('dc-pop-last', Date.now()) || !store.set('dc-pop-session', s)) return false;
      const history = object(store.get('dc-pop-seen')); history[c.id] = Date.now(); store.set('dc-pop-seen', history);
    }
    previousFocus = document.activeElement; previousOverflow = document.body.style.overflow;
    dialog.showModal(); opened = true; dialog.focus({preventScroll:true}); document.body.style.overflow = 'hidden';
    clearInterval(interval); publish('dc_popup_view'); return true;
  };
  if (forced) { interval = setInterval(show, 500); return; }
  let activeMs = 0, lastTick = Date.now(), scrolled = false, progress = 0;
  document.addEventListener('visibilitychange', () => { lastTick = Date.now(); });
  const updateScroll = () => {
    const range = document.documentElement.scrollHeight - window.innerHeight;
    if (window.scrollY > 24) scrolled = true;
    progress = range > 0 ? window.scrollY / range : 0;
  };
  window.addEventListener('scroll', updateScroll, {passive:true});
  interval = setInterval(() => {
    const now = Date.now();
    if (!document.hidden) { activeMs += Math.min(now - lastTick, 1000); touch(); }
    lastTick = now;
    if (data.page === 'index' ? activeMs >= 15000 && scrolled : activeMs >= 20000 && progress >= .4) show();
  }, 500);
  if (matchMedia('(pointer:fine)').matches) document.addEventListener('mouseout', e => { if (!e.relatedTarget && e.clientY < 8 && activeMs >= 10000) show(); });
})();
